<template>
  <div ref="container">
    <a-modal :title="title" width="95%" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }"
      @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="ipagination" :columns="columns" :loading="loading" @change="handleTableChange">
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { accumulategetByNumber, accumulategetByOutNumberNew } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'UDIOutlistDialog',
  mixins: [JeecgListMixin],
  data () {
    return {
      title: '出库统计详情',
      visible: false,
      model: {},
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      url: {
        list: '/report/getByOutNumber',
      },
      loading: false,
      columns: [
        { title: '接收方', dataIndex: 'inputorName', width: 90, algin: 'center' },
        {
          title: '出库仓库',
          dataIndex: 'depotName',
          width: 140,
        },
        {
          title: '产品码',
          dataIndex: 'code',
          width: 140,
        },
        {
          title: '防伪名称',
          dataIndex: 'piName',
          width: 140,
        },
        {
          title: '产品名称',
          dataIndex: 'materialName',
          width: 140,
        },
        {
          title: 'UDI名称',
          dataIndex: 'udiName',
          width: 140,
        },
        {
          title: '规格',
          dataIndex: 'standard',
          width: 140,
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: 80,
        },

        {
          title: '包装详情',
          dataIndex: 'details',
          width: 120,
        },
        // {
        //   title: '电话号码',
        //   dataIndex: 'phonenum',
        // },
        // {
        //   title: '排序',
        //   dataIndex: 'userBlngOrgaDsplSeq',
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
    }
  },
  created () { },
  methods: {
    async add (e, type) {
      this.title = `${type}统计详情`
      this.columns[1].title = `${type}仓库`
      console.log(e, 'e122')
      this.visible = true
      this.pagination.current = 1

      this.topQueryParam.number = e
      this.loadData(1)
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel () {
      this.close()
    },
    handlePageChange (page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped></style>